<template>
  <div class="w-full px-12">
    <h2 class="font-bold text-gray-dark text-xl mt-5">Answer Description</h2>
    <div class="text-sm text-gray-dark mt-2">
      Write 1-3 concise sentences explaining the user's goal for this Answer.
      Keep it specific, avoid examples unless absolutely necessary, and ensure it does not overlap with other Answers.
    </div>
    <t-textarea v-model="intentDescription"
                class="mt-3"
                :class="textClasses"
                variant="textSection"
                @focus="handleFocus"
                @blur="handleBlur"
                @keydown.esc="handleBlur"
                @input="updateIntentDescription"
                ref="text"
                rows=25
                placeholder="The customer is inquiring about the current status of their package delivery. They want to know where it is in transit and when it is expected to arrive."
    />

    <div class="flex justify-end w-full mt-1 relative">
      <div v-if="intentDescription.length === 0"
           class="text-xs text-gray-dark left-0 absolute">
        If not filled, Answer name is used.
      </div>
      <CharacterCounter :count="intentDescription.length"
                        :limit="MAX_CHARACTERS"
                        class="w-full"
      />
    </div>
  </div>
</template>

<script>
import CharacterCounter from '@/components/editor/message/CharacterCounter.vue'
import intentModule from '@/store/modules/intent.module'
import previewModule from '@/store/modules/preview.module'

const MAX_CHARACTERS = 2000

export default {
  name: 'IntentDescriptionEditor',
  components: { CharacterCounter },

  data() {
    return {
      isInputFocused: true,
      showIsSaved: false,
      MAX_CHARACTERS
    }
  },

  computed: {
    intent: intentModule.getIntent,
    error: previewModule.error,
    errorDescription: previewModule.errorDescription,

    textClasses() {
      if (this.isCharacterLimitError) return 'border-focus-error focus:border-focus-error'
      if (this.isInputFocused) return 'border-focus'
      return 'border-soft'
    },

    intentDescription() {
      return this.intent.description || ''
    },

    isCharacterLimitError() {
      return this.errorDescription?.includes('Answer Description cannot exceed')
    }
  },

  methods: {
    handleFocus() {
      this.isInputFocused = true
    },

    handleBlur() {
      this.isInputFocused = false
      this.$refs.text.blur()
    },

    updateIntentDescription(description) {
      intentModule.setIntent({ ...this.intent, description })
      if (this.isCharacterLimitError && description.length <= this.MAX_CHARACTERS) this.error = null
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.text.focus()
      this.isInputFocused = true
    })
  }
}
</script>
